export default __webpack_public_path__ + "static/media/tete71.9f265e5f.png";